import type { DisciplineGeneralForm } from '../../interfaces'
import type { DisciplineGeneralInfoStore } from './interfaces'

export const actions = {
  setForm (this: DisciplineGeneralInfoStore, payload: DisciplineGeneralInfoStore['form']): void {
    this.form = payload
  },
  setFormField<K extends keyof DisciplineGeneralForm> (
    this: DisciplineGeneralInfoStore,
    key: K,
    value: DisciplineGeneralForm[K],
  ): void {
    if (!this.form) return
    this.form[key] = value
  },
  setSaving (this: DisciplineGeneralInfoStore, payload: DisciplineGeneralInfoStore['saving']): void {
    this.saving = payload
  },
  setActiveModal (this: DisciplineGeneralInfoStore, payload: DisciplineGeneralInfoStore['activeModal']): void {
    this.activeModal = payload
  },
  setMergeIds (this: DisciplineGeneralInfoStore, payload: DisciplineGeneralInfoStore['mergeIds']): void {
    this.mergeIds = payload
  },
}
